import { render } from "./vgoinmonadinfo.vue?vue&type=template&id=4d84f726&scoped=true"
import script from "./vgoinmonadinfo.vue?vue&type=script&lang=js"
export * from "./vgoinmonadinfo.vue?vue&type=script&lang=js"

import "./vgoinmonadinfo.vue?vue&type=style&index=0&id=4d84f726&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d84f726"]])

export default __exports__